"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnumValue = exports.keys = exports.entries = exports.isTruthy = void 0;
/**
 * Useful when using .filter to filter undefined values
 */
var isTruthy = function (item) {
    return !!item;
};
exports.isTruthy = isTruthy;
/** A wrapper around Object.entries that preserves key types  */
function entries(obj) {
    return Object.entries(obj);
}
exports.entries = entries;
function keys(obj) {
    return Object.keys(obj);
}
exports.keys = keys;
/**
 * A type guard that determines if `value` is a valid value in the "as const constant enum" `theEnum`.
 */
function isEnumValue(value, theEnum) {
    if (Object.values(theEnum).includes(value))
        return true;
    return false;
}
exports.isEnumValue = isEnumValue;
